/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { TrackingData } from 'js/lib/retracked';

import { Typography2 } from '@coursera/cds-core';
import { ChevronPreviousIcon } from '@coursera/cds-icons';

import TrackedButton from 'bundles/page/components/TrackedButton';

export type Props = {
  label: string;
  trackingName: string;
  trackingData?: TrackingData;
  ariaLabel?: string;
  onClick: () => void;
};

const styles = {
  mobileSubmenuHeader: css`
    display: flex;
    justify-content: left;
    align-items: center;
    background-color: #f7f7f7;
    padding-top: var(--cds-spacing-200);
    border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-top: none;
    border-left: none;
    border-right: none;
    width: calc(100% + var(--cds-spacing-200) + var(--cds-spacing-200));
    padding-bottom: var(--cds-spacing-200);
    color: var(--cds-color-neutral-primary);
    margin-left: calc(-1 * var(--cds-spacing-200));
  `,
  arrow: css`
    margin-right: var(--cds-spacing-100);
  `,
};

export const MobileNavBackHeader = ({ label, trackingName, trackingData, ariaLabel, onClick }: Props) => {
  return (
    <TrackedButton
      onClick={onClick}
      trackingName={trackingName}
      data={trackingData}
      aria-label={ariaLabel}
      tabIndex={0}
      css={styles.mobileSubmenuHeader}
    >
      <ChevronPreviousIcon size="medium" css={styles.arrow} />
      <Typography2 component="h2" variant="bodyPrimary">
        {label}
      </Typography2>
    </TrackedButton>
  );
};

export default MobileNavBackHeader;
